<script>
import { GlLink, GlSprintf } from '@gitlab/ui';
import PageFooter from '~/javascripts/components/page_footer.vue';
import Tracking from '~/javascripts/tracking';
import {
  TRACKING_CATEGORIES,
  TRACKING_ACTIONS,
  TRACKING_LABELS,
} from '~/javascripts/tracking/constants';
import {
  COOKIE_POLICY,
  LEGACY_ACCOUNT_MESSAGE,
  LINK_GITLAB_ACCOUNT_DOCS_URL,
  PRIVACY_STATEMENT,
} from '../sessions_constants';

export default {
  name: 'FooterApp',
  components: {
    PageFooter,
    GlLink,
    GlSprintf,
  },
  props: {
    legacyAccountSignInUrl: {
      type: String,
      required: true,
    },
  },
  created() {
    this.tracking = new Tracking();
  },
  methods: {
    trackLegacySignInClick() {
      this.tracking.event(TRACKING_CATEGORIES.webstore, TRACKING_ACTIONS.clickLink, {
        label: TRACKING_LABELS.signInWithLegacyAccount,
        property: 'footer_navigation',
      });
    },
  },
  LEGACY_ACCOUNT_MESSAGE,
  LINK_GITLAB_ACCOUNT_DOCS_URL,
  COOKIE_POLICY,
  PRIVACY_STATEMENT,
};
</script>

<template>
  <page-footer>
    <template #card-content>
      <p class="gl-text-gray-600" data-testid="legacy-account-message">
        <gl-sprintf :message="$options.LEGACY_ACCOUNT_MESSAGE">
          <template #legacySignInLink="{ content }">
            <gl-link
              :href="legacyAccountSignInUrl"
              data-testid="legacy-sign-in-url"
              @click="trackLegacySignInClick"
              >{{ content }}</gl-link
            >
          </template>
          <template #linkGitLabAccountLink="{ content }">
            <gl-link
              :href="$options.LINK_GITLAB_ACCOUNT_DOCS_URL"
              data-testid="link-gitlab-account-link"
              >{{ content }}</gl-link
            >
          </template>
        </gl-sprintf>
      </p>
    </template>
    <template #policies-content>
      <gl-link :href="$options.COOKIE_POLICY" data-testid="cookie-policy"> Cookie Policy </gl-link>
      <span
        class="gl-border-gray-100 gl-border-0 gl-border-r-1 gl-border-solid gl-ml-2 gl-mr-3"
      ></span>
      <gl-link class="ot-sdk-show-settings" href="#" data-testid="cookie-preferences">
        Cookie Preferences
      </gl-link>
      <span
        class="gl-border-gray-100 gl-border-0 gl-border-r-1 gl-border-solid gl-ml-2 gl-mr-3"
      ></span>
      <gl-link :href="$options.PRIVACY_STATEMENT" data-testid="privacy-statement">
        Privacy Statement
      </gl-link>
    </template>
  </page-footer>
</template>
